// Answers which stop the flow and lead to an Inspection Needed screen
export default {
    100: true, // Warning light damage : Yes
    200: true, // Mechanical issues    : Yes
    300: true, // Major modifications  : Yes
    500: '3', // Dents, dings, hail damage      : Extensive
    600: '3', // Scratches, chips or dull paint : Extensive
    1100: '3', // Seats damage                  : Extensive
    1200: '3', // Carpet or headliner damage    : Extensive
    1510: true, // Accidental damage/ insurance claim more than X : Yes
    1600: true, // Odometer discrepancy                           : Yes
    1700: true, // Stolen and recovered                           : Yes
    1800: true, // Salvaged/written off or rebuilt title          : Yes
    1900: true, // Flood damage                                   : Yes
};
